import "@/App.css";
import { BrowserRouter, Route, Routes } from "react-router-dom";
import { BookingProvider } from "@/context/BookingContext";
import Layout from "@/components/np/Layout";
import Home from "@/pages/Home";
import Besvar from "@/pages/Besvar";
import Behandlingar from "@/pages/Behandlingar";
import Om from "@/pages/Om";
import KlinikerBoka from "@/pages/KlinikerBoka";
import NotFound from "@/pages/NotFound";

function App() {
  return (
    <BrowserRouter>
      <BookingProvider>
        <Routes>
          <Route element={<Layout />}>
            <Route index element={<Home />} />
            <Route path="besvar" element={<Besvar />} />
            <Route path="behandlingar" element={<Behandlingar />} />
            <Route path="om-nordic-prolo" element={<Om />} />
            <Route path="kliniker-boka" element={<KlinikerBoka />} />
            <Route path="*" element={<NotFound />} />
          </Route>
        </Routes>
      </BookingProvider>
    </BrowserRouter>
  );
}

export default App;
